import React from 'react';
import DatePicker from 'react-datepicker';

import styles from './SearchByDate.module.scss';

// Supported manual-entry formats: '/' is used for display, the rest are
// accepted so typing with '.' or '-' separators (or a 2-digit year) parses
// correctly instead of silently falling back to today's month.
const SUPPORTED_DATE_FORMATS = [
  'dd/MM/yyyy',
  'dd-MM-yyyy',
  'dd.MM.yyyy',
  'dd/MM/yy',
  'dd-MM-yy',
  'dd.MM.yy',
];

const SearchByDate = (props) => {
  const { onStartDateChange, onEndDateChange, startDate, endDate, disabled } = props;

  return (
    <div className={styles.date_picker__div}>
      <DatePicker
        className={styles.date_picker__input}
        selected={startDate}
        onChange={(date) => onStartDateChange(date)}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        maxDate={endDate}
        placeholderText='Start date'
        isClearable
        dateFormat={SUPPORTED_DATE_FORMATS}
        disabled={disabled}
      />
      <span className={styles.date_picke__p}>&#160;-&#160;</span>
      <DatePicker
        className={styles.date_picker__input}
        selected={endDate}
        onChange={(date) => onEndDateChange(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        placeholderText='End date'
        isClearable
        dateFormat={SUPPORTED_DATE_FORMATS}
        disabled={disabled}
      />
    </div>
  );
};

export default SearchByDate;
